export default __webpack_public_path__ + "static/media/solana-sol-logo.88dd9cd2.png";